import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StickyCall from "../components/StickyCall";
import { Phone, HeartHandshake, CheckCircle2 } from "lucide-react";
import { site } from "../mock";
import { CallbackButton } from "../components/PageBlocks";

export default function RetourAffectif() {
  return (
    <div>
      <Header />
      <StickyCall />
      <section className="hero-radial py-14 md:py-20">
        <div className="container-narrow grid md:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="order-1 md:order-none">
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold-deep mb-3">Spécialité phare</p>
            <h1 className="font-display text-4xl md:text-5xl gold-gradient-text mb-4">Ramener l'être aimé, sceller votre couple</h1>
            <div className="gold-divider my-5 max-w-[220px]" />
            <p className="text-gold-soft/95 leading-relaxed mb-4">
              Une rupture qui vous brise, un silence qui vous consume, une trahison qui vous obsède ? Le <span className="text-gold">retour affectif</span> est la spécialité la plus demandée de Maître Diamma — et celle où sa réputation dépasse largement Orléans.
            </p>
            <p className="text-gold-soft/95 leading-relaxed mb-6">
              Grâce à des rituels puissants issus de sa lignée africaine, il rallume la flamme, éloigne les tiers, dissout les malentendus et fait naître un attachement plus profond qu'avant. De nombreux couples pensés « perdus » se sont retrouvés.
            </p>
            <div className="flex flex-wrap gap-3">
              <CallbackButton id="retouraffectif-hero" context="Retour affectif" />
              <a href={`tel:${site.phoneRaw}`} className="btn-gold inline-flex rounded-md px-6 py-3 items-center gap-2">
                <Phone className="w-4 h-4" /> Parler à Maître Diamma
              </a>
            </div>
          </div>
          <div className="relative rounded-xl overflow-hidden gold-border-strong order-2 md:order-none">
            <img src="/images/diamma-blanc.jpg" alt="Maître Diamma, spécialiste du retour affectif à Orléans" className="w-full h-[300px] md:h-[440px] object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
          </div>
        </div>
      </section>

      <section className="py-14 md:py-16 bg-charcoal">
        <div className="container-narrow grid md:grid-cols-2 gap-6 md:gap-10">
          <div className="card-onyx rounded-xl p-8">
            <HeartHandshake className="w-8 h-8 text-gold mb-3" />
            <h3 className="font-display text-xl text-gold mb-3">Ce que le rituel peut faire pour vous</h3>
            <ul className="space-y-2">
              {[
                "Faire revenir la personne aimée, même après une longue absence",
                "Provoquer une véritable réconciliation, sincère et durable",
                "Éloigner définitivement une rivale ou un rival",
                "Empêcher une rupture qui semble imminente",
                "Ranimer le désir et la complicité d'un couple",
                "Obtenir une déclaration ou une décision claire"
              ].map((v) => (
                <li key={v} className="flex items-start gap-2 text-sm text-gold-soft/95"><CheckCircle2 className="w-4 h-4 text-gold mt-0.5" /> {v}</li>
              ))}
            </ul>
          </div>
          <div className="card-onyx rounded-xl p-8">
            <h3 className="font-display text-xl text-gold mb-3">Comment se déroule un rituel</h3>
            <ol className="space-y-3 text-sm text-gold-soft/95">
              <li><span className="text-gold font-semibold">1.</span> Prise de contact gratuite et confidentielle au {site.phone}.</li>
              <li><span className="text-gold font-semibold">2.</span> Écoute attentive puis lecture spirituelle de votre situation.</li>
              <li><span className="text-gold font-semibold">3.</span> Choix du rituel adapté : magie blanche, prière, offrande sacrée.</li>
              <li><span className="text-gold font-semibold">4.</span> Exécution du travail selon le calendrier lunaire propice.</li>
              <li><span className="text-gold font-semibold">5.</span> Suivi personnalisé jusqu'à la manifestation des premiers signes.</li>
            </ol>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
